<template>
  <q-scroll-area style="height: calc(100vh - 50px) !important">
    <q-page fluid style="min-height: 0px">
      <div class="row full-width">
        <div class="col-12">
          <q-card class="full-width" style="min-height: calc(100vh - 90px)">
            <q-card-section class="bg-white text-accent">
              <div class="row items-center q-pa-md">
                <div class="col-12 col-md-3 col-xl-2">
                  <div class="profileImageContainer">
                    <q-img
                      :src="currentUserData.profileImgUrl"
                      style="border-radius: 5px"
                    >
                    </q-img>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div
                    :class="{ 'q-ml-md': $q.screen.gt.md }"
                    class="q-pa-md profileTextContainer"
                  >
                    <h3 class="q-mb-none">
                      {{ currentUserData.name }}
                    </h3>
                    <p class="q-mb-none q-mr-xl">
                      {{ currentUserData.email }}
                    </p>
                    <p class="text-capitalize">
                      {{ currentUserData.role | splitCamelCase }}
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-3 col-xl-4">
                  <div class="row">
                    <div class="col-12">
                      <p style="font-weight: bold !important" class="q-mb-none">
                        Organization
                      </p>
                      <div class="row">
                        <div
                          v-for="(org, index) in organizations"
                          :key="`organization_${index}`"
                          v-if="index < 6"
                          style="
                            min-width: 50px;
                            max-width: 50px;
                            text-align: center;
                          "
                          class="q-ma-xs"
                        >
                          <q-avatar
                            rounded
                            style="margin: auto; position: relative"
                            size="50px"
                            color="red"
                            class="q-pa"
                          >
                            <span style="color: white; font-size: 60%">{{
                              org.name | initials
                            }}</span>
                          </q-avatar>
                          <q-tooltip>{{ org.name }}</q-tooltip>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-12">
                      <p style="font-weight: bold !important" class="q-mb-none">
                        Organization Members
                      </p>
                      <div class="row">
                        <div
                          v-for="(org, index) in organizations"
                          :key="`organization_${index}`"
                          v-if="index < 6"
                          style="
                            min-width: 50px;
                            max-width: 50px;
                            text-align: center;
                          "
                          class="q-ma-xs"
                        >
                          <q-avatar
                            style="margin: auto; position: relative"
                            size="50px"
                            color="red"
                            class="q-pa"
                          >
                            <span style="color: white; font-size: 60%">{{
                              org.name | initials
                            }}</span>
                          </q-avatar>
                          <q-tooltip>{{ org.name }}</q-tooltip>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </q-card-section>

            <q-separator />

            <q-card-section class="profileContentContainer">
              <div class="row">
                <div class="col-12">
                  <h3 class="q-my-xs">Notifications</h3>
                </div>
                <div class="col-12">
                  <q-checkbox
                    dense
                    v-model="formData.deviceEventSummarizedNotifications"
                    :true-value="1"
                    :false-value="0"
                    :toggle-indeterminate="false"
                    label="Receive Daily Summarized Device Event Notification"
                    @input="save()"
                  ></q-checkbox>
                  <br />
                  <q-checkbox
                    dense
                    v-model="formData.deviceEventRealTimeNotifications"
                    :true-value="1"
                    :false-value="0"
                    :toggle-indeterminate="false"
                    label="Receive Device Event Notifications"
                    @input="save()"
                  ></q-checkbox>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-page>
  </q-scroll-area>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        organizations: "organizations/list",
        organizationsLoading: "organizations/listLoading",
      }),
    },
    props: {
      source: String,
    },
    watch: {
      currentUserData: function () {
        this.formData = JSON.parse(JSON.stringify(this.currentUserData));
      },
    },
    data: () => ({
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must have 8+ characters",
        (v) =>
          (v && /(?=.*[A-Z])/.test(v)) ||
          "Password Must contain a capital letter",
        (v) =>
          (v && /(?=.*[a-z])/.test(v)) ||
          "Password Must contain a lowercase letter",
        (v) => (v && /.*[0-9].*/.test(v)) || "Password Must contain a number",
        (v) =>
          (v && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v)) ||
          "Password must have a special character",
      ],

      formData: {
        deviceEventSummarizedNotifications: 0,
        deviceEventRealTimeNotifications: 0,
      },
    }),
    mounted() {
      this.$store.dispatch("organizations/loadAll");
      this.formData = JSON.parse(JSON.stringify(this.currentUserData));
    },
    methods: {
      save() {
        this.$store
          .dispatch("users/saveProfile", this.formData)
          .then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message,
              });
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .profileImageContainer {
    max-width: 270px;
    margin: auto;
  }
  .profileContentContainer {
    h3 {
      font-size: 25px;
      font-weight: bold;
    }
  }

  .profileTextContainer {
    h3 {
      font-size: 40px;
      font-weight: bold;
    }

    p {
      font-weight: bold;
      display: inline-block;
    }
  }
</style>
